import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-admin-orders-enquiries',
  templateUrl: './admin-orders-enquiries.component.html',
  styleUrls: ['./admin-orders-enquiries.component.scss']
})
export class AdminOrdersEnquiriesComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();
  enquiries: any[] = [];
  isLoading = false;

  // View modal
  isViewModalOpen = false;
  viewEnquiry: any = null;

  constructor(
    private appService: AppService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.loadEnquiries();
  }

  loadEnquiries(): void {
    this.isLoading = true;
    this.appService.getAllEnquiries()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.enquiries = data;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching enquiries', err);
          this.toaster.error('Failed to load enquiries');
          this.isLoading = false;
        }
      });
  }

  openViewModal(enquiry: any): void {
    this.viewEnquiry = enquiry;
    this.isViewModalOpen = true;
  }

  closeViewModal(): void {
    this.isViewModalOpen = false;
    this.viewEnquiry = null;
  }

  toggleEnquiryStatus(enquiry: any, event: any): void {
    const isChecked = event.target.checked;
    const newStatus = isChecked ? 'OPEN' : 'CLOSED';
    this.spinner.show();

    const payload = {
      enquiryId: enquiry.enquiryId,
      status: newStatus
    };

    this.appService.updateEnquiryStatus(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.toaster.success(`Enquiry marked as ${newStatus}`);
          enquiry.enquiryStatus = newStatus;
        },
        error: (err) => {
          console.error('Update enquiry status error:', err);
          this.spinner.hide();
          this.toaster.error('Failed to update enquiry status');
          event.target.checked = !isChecked; // Revert switch UI
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
